"use client";
import React, { useEffect, useState } from "react";
import { NavLink, useParams, useLocation, useNavigate } from "react-router-dom";
import { get_tool_sub_cat_api } from "../Config/API";
import toolsImg from "../../src/Assets/images/drilling.png";

export default function Dashboard({ toggle }) {
  const [subCategories, setSubCategories] = useState([]);
  const [type, setType] = useState("");
  const token = JSON.parse(localStorage.getItem("mmt_front_token"));
  const idToken = token.idToken;
  const location = useLocation();
  const { tool_category } = useParams();
  const navigate = useNavigate();

  //   const { path } = location.state
  //  console.log("path", path)
  //   console.log("location 2", location.state.path);
  useEffect(() => {
    if (tool_category && tool_category != "") {
      let payload = {
        uuid: tool_category,
      };
      get_tool_sub_cat_api(payload).then((res) => {
        setSubCategories(res.data.data);
        setType(res.data.tool_type_name);
      });
    }
  }, [tool_category]);

  return (
    <div className="px-10 h-full overflow-y-auto pb-[10%] ">
      <div className="p-6 border-b border-gray-400">
        {/* <div className="">
                        <Image src={toolsImg} width={112} height={31} alt="" />
                    </div> */}
        <span
          className="text-base text-secondary-color cursor-pointer"
          onClick={() => {
            navigate(-1);
          }}
        >
          {" "}
          {location.state.path_arr[0]}
        </span>{" "}
        <span>{"/"}</span>{" "}
        <span className="text-base text-main-color">
          {" "}
          {location.state.path_arr[1]}{" "}
        </span>
      </div>

      <div className="grid grid-cols-3 gap-5 mt-10">
        {subCategories?.map((cat, index) => (
          <div
            className="text-center p-8 rounded-md cursor-pointer gridboxshadow"
            key={index}
            onClick={() => {
              navigate(`/product/${cat.uuid}`, {
                state: {
                  path_arr: [...location.state.path_arr, cat.description],
                },
              });
              toggle();
            }}
          >
            <div className="toolcatimg">
              <img src={toolsImg} width={112} height={31} alt="" />
            </div>
            <h2 className="mb-3 text-lg mt-5"> {cat.description}</h2>

            <p>
              {" "}
              {/* Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry */}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
